import React from 'react'

import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import { minReportDate } from '../config'
import ReactTooltip from 'react-tooltip'

// OpinaryDatePicker is just a thin wrapper that ensures that all the dates
// have a minDate set. It is used to ensure that it's easy to change to any other date.
function OpinaryDatePicker(props) {
  // Unless explicitly specified from the component using it,
  // we limit the date to minReportDate.
  let newProps = { ...props }
  if (!newProps.minDate) {
    newProps['minDate'] = minReportDate
  }

  let tooltip
  if (props.showToolTip) {
    tooltip = (
      <div>
        <i
          data-tip
          data-for="registerTip"
          className="fa fa-info-circle"
          style={{ padding: '5px' }}
          aria-hidden="true"
        />

        <ReactTooltip id="registerTip" place="top" effect="solid">
          We can display data starting from November 2019 <br />
          please contact us if you need older time frames.
        </ReactTooltip>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex' }}>
      {tooltip}
      <DatePicker {...newProps} />
    </div>
  )
}

export default OpinaryDatePicker



// WEBPACK FOOTER //
// ./src/components/DatePicker.js